import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VplaybookVideoViewerComponent } from 'src/app/shared/components/vplaybook-video-viewer/vplaybook-video-viewer.component';

@NgModule({
  exports: [
    VplaybookVideoViewerComponent
  ],
  declarations: [
    VplaybookVideoViewerComponent
  ],
  imports: [
    CommonModule
  ]
})
export class VplaybookVideoViewerModule { }
